import axios, { AxiosRequestConfig } from 'axios'

import qs from 'qs'

export default axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_API,
  paramsSerializer: (params) => qs.stringify(params)
})

/**
 * Configures an Authorization Header with a Token.
 *
 * @param token Valid Token.
 */
export function withToken (token: string): AxiosRequestConfig {
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
}
